export default {
    ANTIAGING: "antiaging",
    BODYSHOCK: "bodyshock",
    PIGMENTCONTROL: "pigmentcontrol",
    NONE: ""
}